import axios from "axios";

const instance = axios.create({
  baseURL: 'URL/api'
});

// testing
// const baseURL = "https://sk8u3mxmp0.execute-api.us-east-2.amazonaws.com/staging/api/user/";


// production
const baseURL =
"https://sk8u3mxmp0.execute-api.us-east-2.amazonaws.com/production/api/user/";

instance.defaults.baseURL = baseURL;


export async function tokenConfirmation({ commit }, token) {
    try {
      setConfigAxios(token)
      const { data } = await instance.post(`token-confirmation`);
      return data;
    } catch (e) {
      return e;
    }
  }

  export async function setNewPassword({ commit }, payload) {
    try {
      setConfigAxios(payload.token)
      const { data } = await instance.post(`set-password`,{password:payload.password});
      return data;
    } catch (e) {

      return e;
    }
  }

function setConfigAxios(token){
  instance.defaults.headers.common['Authorization'] = token;
}